<template>
  <div class="text-base text-gray-950 font-medium text-left flex items-center">
    <el-image :src="amapayBrand(brandName)" style="height: 24px" fit="sacle-down"></el-image>

    <span class="ml-2">{{ brandName }}</span>
    <span class="ml-2 font-normal">{{ cardNumber }}</span>
  </div>
</template>

<script>
import { BRAND_CARD } from '@/constants/amazon'
import { SHOP_CONFIG } from '@/constants'
export default {
  props: {
    amazonCard: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    card() {
      return this.amazonCard?.split(' ') || ['', '']
    },
    brandName() {
      return this.card.slice(0, -1).join(' ')
    },
    cardNumber() {
      return `... $1`.replace('$1', [...this.card].pop())
    },
  },
  methods: {
    amapayBrand(brand) {
      const brandObj = {
        [BRAND_CARD.VISA]: SHOP_CONFIG.BRAND_VISA,
        [BRAND_CARD.AMEX]: SHOP_CONFIG.BRAND_AMEX,
        [BRAND_CARD.DINNERSCLUB]: SHOP_CONFIG.BRAND_DINNERCLUB,
        [BRAND_CARD.MASTER]: SHOP_CONFIG.BRAND_MASTER,
        [BRAND_CARD.JCB]: SHOP_CONFIG.BRAND_JCB,
      }
      return brandObj[brand] || SHOP_CONFIG.BRAND_DEFAULT
    },
  },
}
</script>
